import React from 'react';

import { Layout } from 'components/Layout';
import { Heading, HeadingVariant } from 'components/Heading';

import styles from './Cookies.module.scss';

export const Cookies: React.FC = () => (
  <Layout>
    <div className={styles.wrapper}>
      <Heading level={1} variant={HeadingVariant.inverted}>
        Cookies
      </Heading>
      <Heading level={3} variant={HeadingVariant.inverted}>
        Vad är en cookie?
      </Heading>
      <p>
        En cookie är en liten textfil som lagras på din dator eller mobila enhet när du besöker en
        webbplats. Cookies används för att erbjuda en bättre användarupplevelse och för att vissa
        funktioner på webbplatsen ska fungera. Det finns tre typer av cookies – temporära,
        permanenta och så kallade tredjepartscookies:
      </p>
      <p>
        <strong>Temporära cookies</strong> kallas för session cookies. De lagras temporärt på din
        enhet när du besöker webbplatsen och raderas när webbläsaren stängs. De används för att
        komma ihåg vilka val du har gjort under besöket, till exempel vilka bilar du sökt på.
      </p>
      <p>
        <strong>Permanenta cookies</strong> har ett förinställt utgångsdatum och sparas en längre
        tid på din enhet. De används för att anpassa webbplatsen till dig och de val du gör.
        Permanenta cookies kan även användas för att samla in användarstatistik som används för att
        utveckla webbplatsen.
      </p>
      <p>
        <strong>Tredjepartscookies</strong> placeras på din enhet av en tredje part som Blipp har
        godkänt. Detta förekommer när vi har leverantörer som utför tjänster åt oss, som t.ex. vissa
        analystjänster.
      </p>
      <Heading level={3} variant={HeadingVariant.inverted}>
        Hur använder Blipp cookies?
      </Heading>
      <p>Några exempel på hur Blipp använder cookies:</p>
      <ul>
        <li>
          När du surfar runt på webbplatsen används cookies för att komma ihåg vad du har sökt efter
          och vilka val du har gjort i bokningsformulär, så att du inte behöver uppge informationen
          igen varje gång du byter sida.
        </li>
        <li>
          För att utveckla vår webbplats och skapa en bättre användarupplevelse använder vi cookies
          för att ser hur besökare använder webbplatsen. Med hjälp av den anonyma statistiken kan vi
          anpassa webbplatsen till våra besökare.
        </li>
        <li>
          Cookies används också för målgruppsstyrd annonsering samt för att baserat på besökarens
          aktivitet kunna anpassa erbjudanden och annonser och på så sätt skräddarsy besökarens
          upplevelse av webbplatsen.
        </li>
      </ul>
      <Heading level={3} variant={HeadingVariant.inverted}>
        Stäng av cookies
      </Heading>
      <p>
        Om du inte vill tillåta att vi sparar cookies på din dator eller mobila enhet eller vill
        radera befintliga cookies kan du själv göra detta genom att ändra inställningarna i din
        webbläsare.
      </p>
      <p>
        Vi vill upplysa dig om att du inte kommer att kunna utnyttja alla funktioner på webbplatsen
        om du blockerar användningen av cookies. Om du ångrar dig och vill tillåta cookies, kan du
        när som helst göra detta genom att ändra inställningarna i din webbläsare.
      </p>
      <Heading level={3} variant={HeadingVariant.inverted}>
        Tacka nej till tredjepartsannonsering via cookies
      </Heading>
      <p>
        Du måste avanmäla dig på varje enhet du använder när du besöker våra tjänster. Observera att
        funktionen för avanmälan använder en cookie på din enhet, och om du rensar cookies från din
        webbläsare kommer den att ”glömma bort” ditt val.
      </p>
      <p>
        <strong>Så använder vi Facebooks pixel</strong>
      </p>
      <p>
        Blipp använder Facebooks pixel för att marknadsföra Blipp via Facebook. Med hjälp av pixeln
        kan vi hitta kunder på Facebook som visat intresserade för Blipp produkter.
      </p>
      <p>
        <strong>Google Analytics</strong>
      </p>
      <p>
        Vi använder ett program som heter Google Analytics. Google analytics är ett statistikprogram
        som skapats av Google. Med Google Analytics hjälp kan vi på ett bättre sätt förstå hur du
        som användare interagerar med Blipp. Informationen vi får använder vi till att utveckla
        bättre och smartare produkter.
      </p>
      <table aria-label="Destinations">
        <thead>
          <tr>
            <th>Location</th>
            <th>Name of cookie</th>
            <th>Type of cookie</th>
            <th>Purpose of cookie</th>
            <th>Storage time</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Blipp.se</td>
            <td>BLIPP_SESSION</td>
            <td>First-party</td>
            <td>Security</td>
            <td>24 hours</td>
          </tr>
          <tr>
            <td>Blipp.se</td>
            <td>Cookie_management</td>
            <td>First-party</td>
            <td>Dismiss Cookie Banner</td>
            <td>24 hours</td>
          </tr>
          <tr>
            <td>Blipp.se</td>
            <td>ga, gat_gtag_UA_136610269_1, _gid</td>
            <td>Third-party</td>
            <td>Google Analytics Cookies</td>
            <td>24 hours</td>
          </tr>
        </tbody>
      </table>
    </div>
  </Layout>
);
